import ApplicationModel from '../../../../models/applications/api/ApplicationModel';

// Filters applications by name with the Management tab's search syntax.
// Supports: !"exclude"|term1|term2 format
// Pipe separates AND conditions, !" before quoted text means exclude
export const filterApplicationsBySearch = (applications: ApplicationModel[], searchTerm: string): ApplicationModel[] => {
    if (!searchTerm.trim()) return applications;

    const terms = searchTerm.split('|').map(t => t.trim()).filter(t => t);
    const exclusionTerms: string[] = [];
    const inclusionTerms: string[] = [];

    terms.forEach(term => {
        // Check if it's an exclusion term: !"text" or !'text'
        const exclusionMatch = term.match(/^!"(.+)"$/) || term.match(/^!'(.+)'$/);
        if (exclusionMatch) {
            exclusionTerms.push(exclusionMatch[1].toLowerCase());
        } else {
            // Remove quotes if present for regular terms
            inclusionTerms.push(term.replace(/^["']|["']$/g, '').toLowerCase());
        }
    });

    return applications.filter(app => {
        const appName = app.name?.toLowerCase() || '';
        if (exclusionTerms.some(term => appName.includes(term))) return false;
        return inclusionTerms.every(term => appName.includes(term));
    });
};
